// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2055":"aa8e51f3","4006":"e36a4cb6","7405":"936854a0","8009":"1c32813e"}[chunkId] + ".chunk.css";
};